export default {
  BASE_URL: 'https://api.themoviedb.org',
  API_KEY: 'e0864e234ad59915a65f6e683712555d',
  POSTER_URL: 'https://themoviedb.org/t/p/w220_and_h330_face',
};
